import type { FeedbackMessages } from './en';

const uk: FeedbackMessages = {
  qualified: {
    title: 'Дякуємо Вам за участь у цьому опитуванні!',
    text: 'Ви можете закрити вікно браузера.\n\nСподіваємося побачити Вас знову найближчим часом.',
  },
  quotaFull: {
    title: 'Це опитування закрито',
    text: 'Дякуємо Вам за інтерес до нашого опитування.\n\nНа жаль, ми вже отримали всі необхідні відповіді.\n\nСподіваємося побачити Вас в одному з наших майбутніх опитувань!',
  },
  terminated: {
    title: 'Дякуємо Вам за те, що поділилися своєю думкою!',
    text: 'Сподіваємося побачити Вас найближчим часом у наших майбутніх опитуваннях. А до того бажаємо Вам чудового дня.\n\nБудь ласка, закрийте це вікно браузера.',
  },
  mismatch: {
    title: 'Дякуємо Вам за інтерес',
    text: 'На жаль, Ви не належите до цільової групи цього конкретного опитування.\n\nВи можете закрити цю сторінку.',
  },
  error: {
    title: 'Ми не можемо обробити Ваш запит',
    linkProblemDetailed:
      'З посиланням, яким Ви скористалися, виникли проблеми. Будь ласка, перевірте, чи посилання в адресному рядку відповідає тому, яке Вам було надано, і спробуйте ще раз.',
    linkProblemGeneric:
      'З посиланням, яким Ви скористалися, виникли проблеми. Будь ласка, спробуйте ще раз.',
    contactPerson:
      'Якщо проблема не зникає, будь ласка, повідомте про це особу, від якої Ви отримали посилання.',
  },
};

export default uk;
